import React from 'react';

const DownloadsHeader = () => {
  return (
    <div className="bg-white px-6 py-6 sm:py-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          Downloads
        </h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Lade dein Profil für Apple Wallet oder Google Wallet herunter und
          exportiere deinen QR-Code.
        </p>
      </div>
    </div>
  );
};

export default DownloadsHeader;
